import type { ComponentPropsWithRef, PropsWithChildren, ReactNode } from "react";
import { useEffect } from "react";

import type { ErrorBoundary } from "react-error-boundary";
import { useErrorHandler } from "react-error-boundary";

import ErrorBoundaryWithLogging from "./ErrorBoundaryWithLogging";

type ChildProps = {
    error?: unknown;
};
type Props = ComponentPropsWithRef<typeof ErrorBoundary> & ChildProps;

const ControlledErrorBoundaryChild = ({ error, children }: PropsWithChildren<ChildProps>): ReactNode => {
    const showBoundaryError = useErrorHandler();

    useEffect(() => {
        if (error) {
            showBoundaryError(error);
        }
    }, [error]);

    return children;
};

const ControlledErrorBoundaryWithLogging = ({ children, error, ...props }: Props) => {
    return (
        <ErrorBoundaryWithLogging {...props}>
            <ControlledErrorBoundaryChild error={error}>{children}</ControlledErrorBoundaryChild>
        </ErrorBoundaryWithLogging>
    );
};

export default ControlledErrorBoundaryWithLogging;
